/* istanbul ignore file */
import { useEffect, useRef } from 'react';
import { useSidebarOverlayContext } from '../contexts/sidebar-overlay';

export const useSidebarOverlay = (showOverlay: boolean, source: string) => {
  const {
    isOverlayVisible,
    showOverlay: showOverlayGlobal,
    hideOverlay,
  } = useSidebarOverlayContext();
  const prevShowOverlay = useRef(showOverlay);

  // Handle overlay visibility changes
  useEffect(() => {
    if (showOverlay === prevShowOverlay.current) {
      return;
    }

    if (showOverlay) {
      showOverlayGlobal(source);
    } else {
      hideOverlay(source);
    }

    prevShowOverlay.current = showOverlay;

    return () => {
      if (prevShowOverlay.current) {
        hideOverlay(source);
      }
    };
  }, [showOverlay, showOverlayGlobal, hideOverlay, source]);

  // Handle sidebar class application
  useEffect(() => {
    const sidebar = document.querySelector('.kandji-sidebar');
    if (!sidebar) return;

    if (isOverlayVisible) {
      sidebar.classList.add('kandji-sidebar--below-dialog');
    } else {
      sidebar.classList.remove('kandji-sidebar--below-dialog');
    }
  }, [isOverlayVisible]);
};
